import React, { Component } from "react";
import "./NacionalidadModal.css";
import { toast } from "react-toastify";

export default class NacionalidadModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(props);
  }

  getInitialState = (props) => {
    const { mode = "create", nacionalidad } = props || {};

    if (mode === "edit" && nacionalidad) {
      return {
        nacionalidad: nacionalidad?.nacionalidad ?? "",
        codigo: nacionalidad?.codigo ?? "",
      };
    }

    return {
      nacionalidad: "",
      codigo: "",
    };
  };

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const modeChanged = prevProps.mode !== this.props.mode;

    const prevId = prevProps?.nacionalidad?.idnacionalidad;
    const nextId = this.props?.nacionalidad?.idnacionalidad;

    if (openedNow || modeChanged || (this.props.show && prevId !== nextId)) {
      this.setState(this.getInitialState(this.props));
    }
  }

  setField = (key, value) => {
    this.setState({ [key]: value });
  };

  validateAndBuildPayload = () => {
    const nacionalidad = String(this.state.nacionalidad || "").trim();
    const codigo = String(this.state.codigo || "").trim().toUpperCase();

    if (!nacionalidad) {
      return { ok: false, message: "La nacionalidad es requerida." };
    }

    if (!codigo) {
      return { ok: false, message: "El código es requerido." };
    }

    return {
      ok: true,
      payload: {
        nacionalidad,
        codigo,
      },
    };
  };

  onSubmit = () => {
    const r = this.validateAndBuildPayload();

    if (!r.ok) {
      toast.info(r.message || "Verifica los campos.");
      return;
    }

    this.props?.onSave?.(r.payload);
  };

  render() {
    const { show, onClose, loading, mode = "create" } = this.props;
    const { nacionalidad, codigo } = this.state;

    if (!show) return null;

    const title =
      mode === "edit" ? "Editar nacionalidad" : "Agregar nacionalidad";

    const btnText =
      mode === "edit" ? "ACTUALIZAR" : "CREAR";

    return (
      <div className="pm-backdrop">
        <div className="pm-modal nm-modal" onClick={(e) => e.stopPropagation()}>
          <div className="pm-head">
            <h3 className="pm-title">{title}</h3>
            <button
              className="pm-x"
              onClick={loading ? null : onClose}
              aria-label="Cerrar"
            >
              ✕
            </button>
          </div>

          <div className="pm-body">
            <div className="pm-field">
              <label>Nacionalidad *</label>
              <input
                value={nacionalidad}
                onChange={(e) => this.setField("nacionalidad", e.target.value)}
                placeholder="Mexicana"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Código *</label>
              <input
                value={codigo}
                onChange={(e) => this.setField("codigo", e.target.value.toUpperCase())}
                placeholder="MEX"
                maxLength={10}
                disabled={loading}
              />
            </div>
          </div>

          <div className="pm-foot pm-footCenter">
            <button className="pm-btn ghost" onClick={onClose} disabled={loading}>
              CANCELAR
            </button>
            <button className="pm-btn" onClick={this.onSubmit} disabled={loading}>
              {btnText}
            </button>
          </div>
        </div>
      </div>
    );
  }
}